/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2025-07-31 10:30:56.

export interface ChangeStatusQuestionnaireRequest {
    questionnaireId: number;
    status: QuestionnaireStatus;
}

export interface DeleteRequest<T> {
    id: T;
}

export interface QuestionnaireFieldOrderRequest {
    id: number;
    startPosition: number;
    endPosition: number;
}

export interface SearchAgentPartyDto {
    search: string;
}

export interface CreateAmlScoreDto {
    name: string;
    description: string;
    amlIdent: string;
}

export interface WebBooleanResponse {
    result: boolean; problemResponseData?: ProblemResponseData|null;
}

export interface UpdateAmlScoreDto {
    id: number;
    name: string;
    description: string;
    amlIdent: string;
}

export interface CreateCountryGroupDto {
    name: string;
    description: string;
    countryGroupIdent: string;
    countryCodes: string[];
    docTypeIds: number[];
}

export interface UpdateCountryGroupDto {
    id: number;
    name: string;
    description: string;
    countryGroupIdent: string;
    countryCodes: string[];
    docTypeIds: number[];
}

export interface UpdateDigitalPartyCaseDto {
    caseId: string;
    subServiceCodes: string[];
    firstName: string;
    middleName: string;
    lastName: string;
    personalID: string;
    dateOfBirth: string;
    placeOfBirth: string;
    stateOfBirth: string;
    countryOfBirth: string;
    additionalNote: string;
    occupation: string;
    maternalName: string;
    parentName: string;
    addressType: string;
    streetName: string;
    residenceNumber: string;
    zip: string;
    cityOfResidence: string;
    stateOfResidence: string;
    countryOfResidence: string;
    email: string;
    phoneNumber: string;
    mobileNumber: string;
    idType: string;
    idNumber: string;
    idCountryOfIssue: string;
    idIssuer: string;
    idDateOfIssue: string;
    idExpiryDate: string;
    idPermanent: boolean;
    resident: boolean;
    citizenship: string;
}

export interface CaseSearchRequest {
    applicationId: string;
    verificationStatus: string;
    subserviceCode: string;
    personalID: string;
    email: string;
    mobileNumber: string;
    phoneNumber: string;
    firstNameFilter: string;
    lastNameFilter: string;
    creationTimePeriodFrom: string;
    creationTimePeriodTo: string;
    completeTimePeriodFrom: string;
    completeTimePeriodTo: string;
    page: number;
    size: number;
}

export interface CreateDocTypeDto {
    name: string;
    description: string;
    docIdent: string;
}

export interface UpdateDocTypeDto {
    id: number;
    name: string;
    description: string;
    docIdent: string;
}

export interface FileSystemResource extends AbstractResource, WritableResource {
    path: string;
}

export interface SearchRequest extends Serializable {
    filters: FilterRequest[];
    sorts: SortRequest[];
    page: number;
    size: number;
}

export interface MultipartFile extends InputStreamSource {
    contentType: string;
    name: string;
    bytes: any;
    empty: boolean;
    resource: Resource;
    size: number;
    originalFilename: string;
}

export interface ChangeStatusPartyCaseDto {
    partyCaseId: number;
    status: PartyCaseStatus;
    commentForClient: string;
    commentForSystem: string;
    amlScoreId: number;
    riskScoreId: number;
}

export interface CreatePartyCaseDto {
    name: string;
    partyId: string;
    selfCreating: boolean;
    userId: string;
    partyTypeId: number;
    subServiceCodes: string[];
    commentForClient: string;
    commentForSystem: string;
}

export interface SetPartyCaseVerificationDto {
    id: number;
    verificationType: VerificationType;
    videoLocation: string;
    verifiedUntil: DateAsString;
}

export interface UpdatePartyCaseDto {
    id: number;
    name: string;
}

export interface CreatePartyCasePostponeDto {
    partyCaseId: number;
    postponeDays: number;
}

export interface UpdatePartyCasePostponeDto {
    id: number;
    partyCaseId: number;
    postponeDays: number;
}

export interface AddPartyCaseToScreeningListDto {
    partyCaseId: number;
    screeningListId: string;
}

export interface SearchScreeningListDto {
    name: string;
    screeningListTypeId: number;
    limit: number;
}

export interface SetActivePartyCaseScreeningListDto {
    id: number;
    active: boolean;
}

export interface CreatePartyDto {
    partyTypeId: number;
    riskScoreId: number;
    selfRegistration: boolean;
    userId: string;
    entityFields: QuestionnaireFilledFieldDto[];
    questionnaireSetId: number;
    subServiceCode: string;
}

export interface FillingPartyQuestionnaireDto {
    partyCaseId: number;
    questionnaireId: number;
    fields: QuestionnaireFilledFieldDto[];
    errorData: any;
}

export interface CreatePartyTypeDto {
    name: string;
    completedStatusExpirationNotifyInterval: CompletedStatusExpirationNotifyInterval;
    completedStatusPeriodNotifyBeforeExpireInDays: number;
    entityType: PartyTypeEntityType;
    applicationId: string;
    deliverViaEmailExpirationNotify: boolean;
    deliverViaSmsExpirationNotify: boolean;
    showLoginExpirationNotify: boolean;
    hasServices: boolean;
    hasVideoIdentification: boolean;
    entityFields: QuestionnaireFieldIdentity[];
}

export interface UpdatePartyTypeDto {
    id: number;
    name: string;
    completedStatusExpirationNotifyInterval: CompletedStatusExpirationNotifyInterval;
    completedStatusPeriodNotifyBeforeExpireInDays: number;
    entityType: PartyTypeEntityType;
    applicationId: string;
    deliverViaEmailExpirationNotify: boolean;
    deliverViaSmsExpirationNotify: boolean;
    showLoginExpirationNotify: boolean;
    hasServices: boolean;
    hasVideoIdentification: boolean;
    entityFields: QuestionnaireFieldIdentity[];
}

export interface CreateProcessDto {
    code: string;
    name: string;
    description: string;
}

export interface UpdateProcessDto {
    id: number;
    code: string;
    name: string;
    description: string;
}

export interface CreateQuestionnaireDto {
    name: string;
    questionnaireType: QuestionnaireType;
    questionnaireIdent: string;
    refNumber: string;
    maxDuration: number;
    minPoints: number;
    processId: number;
}

export interface UpdateQuestionnaireDto {
    id: number;
    name: string;
    questionnaireIdent: string;
}

export interface CreateQuestionnaireFieldDto {
    questionnaireId: number;
    name: string;
    position: number;
    mandatory: boolean;
    hasComment: boolean;
    identity: QuestionnaireFieldIdentity;
    fieldInfo: FieldInfoUnion;
}

export interface QuestionnaireFieldRequestDto {
    questionnaireId: number;
    listOfFields: QuestionnaireFieldForListDto[];
}

export interface QuestionnaireFieldFromTemplateDto {
    questionnaireId: number;
    templateFieldId: number;
    mandatory: boolean;
    hasComment: boolean;
    points: number;
}

export interface UpdateQuestionnaireFieldDto {
    id: number;
    questionnaireId: number;
    name: string;
    position: number;
    mandatory: boolean;
    hasComment: boolean;
    identity: QuestionnaireFieldIdentity;
    fieldInfo: FieldInfoUnion;
}

export interface CreateQuestionnaireRiskDto {
    riskScoreId: number;
    questionnaireId: number;
}

export interface UpdateQuestionnaireRiskDto {
    id: number;
    riskScoreId: number;
    questionnaireId: number;
}

export interface CreateQuestionnaireSetDto {
    name: string;
    partyTypeId: number;
    subServiceCodes: string[];
    type: QuestionnaireSetType;
    questionnaireIds: number[];
}

export interface UpdateQuestionnaireSetDto {
    id: number;
    name: string;
    partyTypeId: number;
    subServiceCodes: string[];
    type: QuestionnaireSetType;
    questionnaireIds: number[];
}

export interface CreateRiskScoreDto {
    name: string;
    description: string;
    riskIdent: string;
    duration: number;
    scoreValue: number;
    notification: number;
    notificationChannel: NotificationChannelType;
}

export interface UpdateRiskScoreDto {
    id: number;
    name: string;
    description: string;
    riskIdent: string;
    duration: number;
    scoreValue: number;
    notification: number;
    notificationChannel: NotificationChannelType;
}

export interface CreateTemplateFieldDto {
    name: string;
    fieldInfo: FieldInfoUnion;
}

export interface UpdateTemplateFieldDto {
    id: number;
    name: string;
    fieldInfo: FieldInfoUnion;
}

export interface WebListResponseEntity<T> {
    result: T[]; problemResponseData?: ProblemResponseData|null;
}

export interface AgentPartyDto {
    id: string;
    companyName: string;
    tradeName: string;
    typeOfLegalEntity: string;
    registrationNumber: string;
    taxId: string;
    registeredActivity: string;
    registrationDate: string;
    stateOfRegistration: string;
    countryOfRegistration: string;
    registrationAddress: string;
    mailingAddress: string;
    city: string;
    postalCode: string;
    primaryPhone: string;
    webSite: string;
    formOfOwnership: string;
    businessType: string;
    category: string;
    statisticalGroup: string;
}

export interface WebResponseEntity<T> {
    result: T; problemResponseData?: ProblemResponseData|null;
}

export interface AmlScoreDto {
    id: number;
    name: string;
    description: string;
    amlIdent: string;
    createdAt: DateAsString;
    updatedAt: DateAsString;
    creator: string;
}

export interface WebResponseObject<T> extends WebResponseBase {
    result: T;
}

export interface CountryGroupDto {
    id: number;
    name: string;
    description: string;
    countryGroupIdent: string;
    createdAt: DateAsString;
    updatedAt: DateAsString;
    createdBy: string;
    countryCodes: string[];
    countries: string[];
    docTypeIds: number[];
    docTypes: DocTypeDto[];
}

export interface CaseDataCommonDto {
    caseId: string;
    subServiceCodes: string[];
    verificationStatus: string;
    createdBy: string;
    creationDateTime: DateAsString;
    lastUpdatedBy: string;
    lastUpdateDateTime: DateAsString;
    firstName: string;
    middleName: string;
    lastName: string;
    personalID: string;
    dateOfBirth: string;
    placeOfBirth: string;
    stateOfBirth: string;
    countryOfBirth: string;
    addressType: string;
    streetName: string;
    residenceNumber: string;
    zip: string;
    cityOfResidence: string;
    stateOfResidence: string;
    countryOfResidence: string;
    idType: string;
    idNumber: string;
    countryOfIdIssue: string;
    idIssuer: string;
    idDateOfIssue: string;
    idExpiryDate: string;
    idPermanent: boolean;
    resident: boolean;
    citizenship: string;
    phoneNumber: string;
    mobileNumber: string;
    email: string;
    parentName: string;
    maternalName: string;
    occupation: string;
    additionalNote: string;
}

export interface UserCaseDto extends CaseDataCommonDto {
    entryId: string;
    userId: string;
}

export interface CaseSearchResponseDto {
    page: number;
    size: number;
    registrationList: UserCaseDto[];
}

export interface DocTypeDto {
    id: number;
    name: string;
    description: string;
    docIdent: string;
    createdAt: DateAsString;
    updatedAt: DateAsString;
    creator: string;
}

export interface OutputStream extends Closeable, Flushable {
}

export interface URL extends Serializable {
}

export interface URI extends Comparable<URI>, Serializable {
}

export interface AbstractResource extends Resource {
}

export interface WritableResource extends Resource {
    outputStream: OutputStream;
    writable: boolean;
}

export interface FilterRequest extends Serializable {
    key: string;
    operator: Operator;
    field_type: FieldType;
    value: any;
    value_to: any;
    values: any[];
}

export interface SortRequest extends Serializable {
    key: string;
    direction: SortDirection;
}

export interface Serializable {
}

export interface WebPageResponseEntity<T> extends WebResponseEntity<GetPagingResponseDto<T>> {
    body: WebResponseObject<GetPagingResponseDto<T>>;
}

export interface FileInfoDto {
    id: number;
    name: string;
    docTypeId: number;
    partyCaseId: number;
    location: string;
    creator: string;
    createdAt: DateAsString;
    verified: boolean;
}

export interface Resource extends InputStreamSource {
    description: string;
    open: boolean;
    file: any;
    readable: boolean;
    url: URL;
    uri: URI;
    filename: string;
}

export interface InputStreamSource {
    inputStream: any;
}

export interface PartyCaseDto {
    id: number;
    name: string;
    partyId: string;
    registrationIdInPartyService: string;
    subServiceCodes: string[];
    partyCaseType: PartyCaseType;
    status: PartyCaseStatus;
    commentForClient: string;
    commentForSystem: string;
    completedExpirationDate: DateAsString;
    questionnaireIds: number[];
}

export interface PartyCaseTreeDto {
    id: number;
    name: string;
    partyId: string;
    party: PartyDto;
    partyType: PartyTypeDto;
    subServiceCodes: string[];
    partyCaseType: PartyCaseType;
    status: PartyCaseStatus;
    amlScore: AmlScoreDto;
    amlDate: DateAsString;
    riskScore: RiskScoreDto;
    riskDate: DateAsString;
    completedExpirationDate: DateAsString;
    verificationType: VerificationType;
    videoLocation: string;
    verifiedUntil: DateAsString;
    questionnaireIds: number[];
}

export interface PartyCaseGroupDto {
    id: number;
    partyId: string;
    subServiceCodes: string[];
    riskScore: RiskScoreDto;
}

export type Mono<T> = T & {
}

export interface PartyCaseVerificationDto {
    redirectionUrl: string;
}

export interface PartyCasePostponeDto {
    id: number;
    partyCaseId: number;
    postponeDays: number;
}

export interface PartyCaseScreeningListDto {
    id: number;
    partyCaseId: number;
    screeningListName: string;
    screeningListId: string;
    screeningListItemId: string;
    active: boolean;
}

export interface ScreeningListTypeDto {
    id: number;
    name: string;
}

export interface ScreeningListDto {
    screeningListId: string;
    name: string;
    description: string;
    active: boolean;
    screeningListTypeId: number;
}

export interface QuestionnaireFilledFieldDto {
    questionnaireFieldId: number;
    name: string;
    value: string;
    position: number;
    availableItems: OrganizationItemField[];
    ownershipItems: QuestionnaireFilledOwnershipItemDto[];
    fieldType: QuestionnaireFieldType;
    identity: QuestionnaireFieldIdentity;
    fieldInfo: FieldInfoUnion;
    comment: string;
    hasComment: boolean;
    mandatory: boolean;
}

export interface PartyDto {
    id: string;
    partyTypeId: number;
    partyType: PartyTypeDto;
    riskScoreId: number;
    riskScore: RiskScoreDto;
    addedInAgentNetwork: boolean;
    partyCaseId: number;
    entityFields: QuestionnaireFilledFieldDto[];
    errors: ValidationError[];
}

export interface PartyQuestionnaireFilledDto {
    id: number;
    partyCaseId: number;
    partyCase: PartyCaseDto;
    questionnaireId: number;
    questionnaire: QuestionnaireDto;
    fields: QuestionnaireFilledFieldDto[];
    errorData: ValidationError[];
    complianceErrors: FieldValidationError[];
    fillStatus: FillStatus;
    startFilling: DateAsString;
    endFilling: DateAsString;
    totalPoints: number;
}

export interface PartyTypeDto {
    id: number;
    name: string;
    completedStatusExpirationNotifyInterval: CompletedStatusExpirationNotifyInterval;
    completedStatusPeriodNotifyBeforeExpireInDays: number;
    entityType: PartyTypeEntityType;
    applicationId: string;
    deliverViaEmailExpirationNotify: boolean;
    deliverViaSmsExpirationNotify: boolean;
    showLoginExpirationNotify: boolean;
    hasServices: boolean;
    hasVideoIdentification: boolean;
    entityFields: QuestionnaireFieldIdentity[];
}

export interface ProcessDto {
    id: number;
    code: string;
    name: string;
    description: string;
}

export interface QuestionnaireDto {
    id: number;
    name: string;
    questionnaireType: QuestionnaireType;
    questionnaireIdent: string;
    creator: string;
    createdAt: DateAsString;
    questionnaireStatus: QuestionnaireStatus;
    questionnaireActionList: QuestionnaireAction[];
    refNumber: string;
    personForm: boolean;
    maxDuration: number;
    minPoints: number;
    processId: number;
    process: ProcessDto;
}

export interface QuestionnaireDtoFull {
    questionnaireInfo: QuestionnaireDto;
    fields: QuestionnaireFieldDto[];
}

export interface FieldInfo {
    fieldType: "STRING" | "NUMBER" | "DATE" | "DATE_TIME" | "OWNERSHIP" | "BOOLEAN" | "LABEL" | "DYNAMIC_LIST" | "STATIC_LIST" | "QUESTION_LIST";
}

export interface QuestionnaireFieldDto {
    id: number;
    questionnaireId: number;
    name: string;
    position: number;
    mandatory: boolean;
    hasComment: boolean;
    identity: QuestionnaireFieldIdentity;
    fieldInfo: FieldInfoUnion;
}

export interface QuestionnaireFieldForListDto {
    name: string;
    fieldInfo: FieldInfoUnion;
    templateId: number;
    mandatory: boolean;
    hasComment: boolean;
}

export interface QuestionnaireRiskDto {
    id: number;
    riskScoreId: number;
    questionnaireId: number;
}

export interface RiskScoreDto {
    id: number;
    name: string;
    description: string;
    riskIdent: string;
    duration: number;
    scoreValue: number;
    notification: number;
    notificationChannel: NotificationChannelType;
    createdAt: DateAsString;
    updatedAt: DateAsString;
    creator: string;
}

export interface QuestionnaireSetDto {
    id: number;
    name: string;
    questionnaireId: number;
    partyTypeId: number;
    partyType: PartyTypeDto;
    subServiceCodes: string[];
    type: QuestionnaireSetType;
    questionnaires: QuestionnaireDto[];
}

export interface ReportDto {
    status: string;
    count: number;
}

export interface TemplateFieldDto {
    id: number;
    name: string;
    fieldInfo: FieldInfoUnion;
}

export interface ProblemResponseData extends Serializable {
    error: boolean;
    problems: ProblemBase[];
}

export interface WebResponseBase extends Serializable {
    problemResponseData: ProblemResponseData;
}

export interface Closeable extends AutoCloseable {
}

export interface Flushable {
}

export interface GetPagingResponseDto<T> {
    list: T[];
    totalCount: number;
}

export interface OrganizationItemField {
    ownerType: OwnerType;
    questionnaireName: string;
    questionnaireId: number;
}

export interface QuestionnaireFilledOwnershipItemDto {
    ownerType: OwnerType;
    questionnaireId: number;
    share: number;
    fields: QuestionnaireFilledFieldDto[];
}

export interface ValidationError {
    field: string;
    validationType: ValidationType;
    message: string;
}

export interface FieldValidationError {
    message: string;
    field: string;
}

export interface StringField extends FieldInfo {
    fieldType: "STRING";
    length: number;
    predefinedRegEx: PredefinedRegEx;
    regEx: string;
}

export interface IntegerField extends FieldInfo {
    fieldType: "NUMBER";
    minValue: number;
    maxValue: number;
    outsideRange: boolean;
}

export interface DateField extends FieldInfo {
    fieldType: "DATE";
    minDate: DateAsString;
    maxDate: DateAsString;
    outsideRange: boolean;
    validationMode: ValidationMode;
}

export interface DateTimeField extends FieldInfo {
    fieldType: "DATE_TIME";
    minDateTime: DateAsString;
    maxDateTime: DateAsString;
    outsideRange: boolean;
    validationMode: ValidationMode;
}

export interface ListDynamicField extends ListField {
    fieldType: "DYNAMIC_LIST";
    source: ListDynamicSource;
    allowOutOfList: boolean;
}

export interface ListStaticField extends ListField {
    fieldType: "STATIC_LIST";
    items: string[];
    allowOutOfList: boolean;
}

export interface ListQuestionField extends ListField {
    fieldType: "QUESTION_LIST";
    items: ListItemField[];
    points: number;
}

export interface OwnershipField extends FieldInfo {
    fieldType: "OWNERSHIP";
    items: OrganizationItemField[];
    minValue: number;
}

export interface BooleanField extends FieldInfo {
    fieldType: "BOOLEAN";
}

export interface LabelField extends FieldInfo {
    fieldType: "LABEL";
    labelMode: LabelMode;
    title: string;
    subTitle: string;
    description: string;
    collapsible: boolean;
}

export interface ResponseEntity<T> {
    result: T;
    problemResponseData?: ProblemResponseData|null;
}

export interface ProblemBase extends Serializable {
    problemCode: number;
    applicationOrigin: string;
    exceptionCode: string;
    message: string;
    details: string;
    type: string;
}

export interface AutoCloseable {
}

export interface Comparable<T> {
}

export interface CorePublisher<T> extends Publisher<T> {
}

export interface ListField extends FieldInfo {
    fieldType: "DYNAMIC_LIST" | "STATIC_LIST" | "QUESTION_LIST";
}

export interface ListItemField {
    value: string;
    expected: boolean;
}

export interface HttpEntity<T> {
    headers: { [index: string]: string[] };
    body: T;
}

export interface Publisher<T> {
}

export interface HttpClient<O> {

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: O; }): RestResponse<R>;
}

export class RestApplicationClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /onboarding/aml-score/create
     * Java method: com.europoint.onboarding.webapi.controllers.AmlScoreController.create
     */
    create$POST$onboarding_amlscore_create(dto: CreateAmlScoreDto, options?: O): RestResponse<WebResponseEntity<AmlScoreDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/aml-score/create`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/aml-score/delete
     * Java method: com.europoint.onboarding.webapi.controllers.AmlScoreController.deleteById
     */
    deleteById$POST$onboarding_amlscore_delete(request: DeleteRequest<number>, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/aml-score/delete`, data: request, options: options });
    }

    /**
     * HTTP GET /onboarding/aml-score/get-all
     * Java method: com.europoint.onboarding.webapi.controllers.AmlScoreController.findAll
     */
    findAll$GET$onboarding_amlscore_getall(options?: O): RestResponse<WebListResponseEntity<AmlScoreDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/aml-score/get-all`, options: options });
    }

    /**
     * HTTP GET /onboarding/aml-score/get-by-id
     * Java method: com.europoint.onboarding.webapi.controllers.AmlScoreController.findById
     */
    findById$GET$onboarding_amlscore_getbyid(queryParams: { id: number; }, options?: O): RestResponse<WebResponseEntity<AmlScoreDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/aml-score/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/aml-score/update
     * Java method: com.europoint.onboarding.webapi.controllers.AmlScoreController.update
     */
    update$POST$onboarding_amlscore_update(dto: UpdateAmlScoreDto, options?: O): RestResponse<WebResponseEntity<AmlScoreDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/aml-score/update`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/country-group/create
     * Java method: com.europoint.onboarding.webapi.controllers.CountryGroupController.create
     */
    create$POST$onboarding_countrygroup_create(dto: CreateCountryGroupDto, options?: O): RestResponse<WebResponseEntity<CountryGroupDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/country-group/create`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/country-group/delete
     * Java method: com.europoint.onboarding.webapi.controllers.CountryGroupController.deleteById
     */
    deleteById$POST$onboarding_countrygroup_delete(request: DeleteRequest<number>, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/country-group/delete`, data: request, options: options });
    }

    /**
     * HTTP POST /onboarding/country-group/get-all
     * Java method: com.europoint.onboarding.webapi.controllers.CountryGroupController.findAll
     */
    findAll$POST$onboarding_countrygroup_getall(options?: O): RestResponse<WebListResponseEntity<CountryGroupDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/country-group/get-all`, options: options });
    }

    /**
     * HTTP GET /onboarding/country-group/get-by-id
     * Java method: com.europoint.onboarding.webapi.controllers.CountryGroupController.findById
     */
    findById$GET$onboarding_countrygroup_getbyid(queryParams: { id: number; }, options?: O): RestResponse<WebResponseEntity<CountryGroupDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/country-group/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/country-group/update
     * Java method: com.europoint.onboarding.webapi.controllers.CountryGroupController.update
     */
    update$POST$onboarding_countrygroup_update(dto: UpdateCountryGroupDto, options?: O): RestResponse<WebResponseEntity<CountryGroupDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/country-group/update`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/direct-party-case/complete
     * Java method: com.europoint.onboarding.webapi.controllers.DirectPartyCaseController.complete
     */
    complete(updateDigitalPartyCaseDto: UpdateDigitalPartyCaseDto, options?: O): RestResponse<WebResponseEntity<CaseDataCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/direct-party-case/complete`, data: updateDigitalPartyCaseDto, options: options });
    }

    /**
     * HTTP POST /onboarding/direct-party-case/create-new-assessment
     * Java method: com.europoint.onboarding.webapi.controllers.DirectPartyCaseController.createNewAssessment
     */
    createNewAssessment(updateDigitalPartyCaseDto: UpdateDigitalPartyCaseDto, options?: O): RestResponse<WebResponseEntity<CaseDataCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/direct-party-case/create-new-assessment`, data: updateDigitalPartyCaseDto, options: options });
    }

    /**
     * HTTP GET /onboarding/direct-party-case/find-by-case-id
     * Java method: com.europoint.onboarding.webapi.controllers.DirectPartyCaseController.findByCaseId
     */
    findByCaseId(queryParams: { caseId: string; }, options?: O): RestResponse<WebResponseEntity<UserCaseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/direct-party-case/find-by-case-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/direct-party-case/find-list
     * Java method: com.europoint.onboarding.webapi.controllers.DirectPartyCaseController.findList
     */
    findList(request: CaseSearchRequest, options?: O): RestResponse<WebResponseEntity<CaseSearchResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/direct-party-case/find-list`, data: request, options: options });
    }

    /**
     * HTTP GET /onboarding/direct-party-case/get-party-case-by-service-code-and-user
     * Java method: com.europoint.onboarding.webapi.controllers.DirectPartyCaseController.findForSelfUserByServiceCode
     */
    findForSelfUserByServiceCode(queryParams: { serviceCode: string; }, options?: O): RestResponse<WebResponseEntity<UserCaseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/direct-party-case/get-party-case-by-service-code-and-user`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/direct-party-case/update
     * Java method: com.europoint.onboarding.webapi.controllers.DirectPartyCaseController.update
     */
    update$POST$onboarding_directpartycase_update(updateDigitalPartyCaseDto: UpdateDigitalPartyCaseDto, options?: O): RestResponse<WebResponseEntity<CaseDataCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/direct-party-case/update`, data: updateDigitalPartyCaseDto, options: options });
    }

    /**
     * HTTP POST /onboarding/doc-type/create
     * Java method: com.europoint.onboarding.webapi.controllers.DocTypeController.create
     */
    create$POST$onboarding_doctype_create(dto: CreateDocTypeDto, options?: O): RestResponse<WebResponseEntity<DocTypeDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/doc-type/create`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/doc-type/delete
     * Java method: com.europoint.onboarding.webapi.controllers.DocTypeController.deleteById
     */
    deleteById$POST$onboarding_doctype_delete(request: DeleteRequest<number>, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/doc-type/delete`, data: request, options: options });
    }

    /**
     * HTTP POST /onboarding/doc-type/get-all
     * Java method: com.europoint.onboarding.webapi.controllers.DocTypeController.findAll
     */
    findAll$POST$onboarding_doctype_getall(options?: O): RestResponse<WebListResponseEntity<DocTypeDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/doc-type/get-all`, options: options });
    }

    /**
     * HTTP GET /onboarding/doc-type/get-by-id
     * Java method: com.europoint.onboarding.webapi.controllers.DocTypeController.findById
     */
    findById$GET$onboarding_doctype_getbyid(queryParams: { id: number; }, options?: O): RestResponse<WebResponseEntity<DocTypeDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/doc-type/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/doc-type/update
     * Java method: com.europoint.onboarding.webapi.controllers.DocTypeController.update
     */
    update$POST$onboarding_doctype_update(dto: UpdateDocTypeDto, options?: O): RestResponse<WebResponseEntity<DocTypeDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/doc-type/update`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/files/delete
     * Java method: com.europoint.onboarding.webapi.controllers.FileController.deleteById
     */
    deleteById$POST$onboarding_files_delete(request: DeleteRequest<number>, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/files/delete`, data: request, options: options });
    }

    /**
     * HTTP GET /onboarding/files/download-file
     * Java method: com.europoint.onboarding.webapi.controllers.FileController.download
     */
    download(queryParams: { id: number; }, options?: O): RestResponse<FileSystemResource> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/files/download-file`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/files/get-all
     * Java method: com.europoint.onboarding.webapi.controllers.FileController.findAll
     */
    findAll$POST$onboarding_files_getall(request: SearchRequest, options?: O): RestResponse<WebPageResponseEntity<FileInfoDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/files/get-all`, data: request, options: options });
    }

    /**
     * HTTP GET /onboarding/files/get-by-id
     * Java method: com.europoint.onboarding.webapi.controllers.FileController.findById
     */
    findById$GET$onboarding_files_getbyid(queryParams: { id: number; }, options?: O): RestResponse<WebResponseEntity<FileInfoDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/files/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/files/send-code
     * Java method: com.europoint.onboarding.webapi.controllers.FileController.sendCode
     */
    sendCode(queryParams: { documentId: number; codeProvider: CodeProvider; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/files/send-code`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/files/sign
     * Java method: com.europoint.onboarding.webapi.controllers.FileController.signDocument
     */
    signDocument(queryParams: { documentId: number; code: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/files/sign`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/files/upload-file
     * Java method: com.europoint.onboarding.webapi.controllers.FileController.uploadFile
     */
    uploadFile(queryParams: { docTypeId: number; partyCaseId: number; file: MultipartFile; }, options?: O): RestResponse<WebResponseEntity<number>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/files/upload-file`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/party-case-postpone/create
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCasePostponeController.create
     */
    create$POST$onboarding_partycasepostpone_create(createPartyCasePostponeDto: CreatePartyCasePostponeDto, options?: O): RestResponse<WebResponseObject<PartyCasePostponeDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/party-case-postpone/create`, data: createPartyCasePostponeDto, options: options });
    }

    /**
     * HTTP POST /onboarding/party-case-postpone/delete
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCasePostponeController.delete
     */
    delete$POST$onboarding_partycasepostpone_delete(request: DeleteRequest<number>, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/party-case-postpone/delete`, data: request, options: options });
    }

    /**
     * HTTP GET /onboarding/party-case-postpone/get-by-id
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCasePostponeController.findById
     */
    findById$GET$onboarding_partycasepostpone_getbyid(queryParams: { id: number; }, options?: O): RestResponse<WebResponseObject<PartyCasePostponeDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/party-case-postpone/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /onboarding/party-case-postpone/get-by-party-case-id
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCasePostponeController.findByPartyCaseId
     */
    findByPartyCaseId(queryParams: { partyCaseId: number; }, options?: O): RestResponse<WebResponseObject<PartyCasePostponeDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/party-case-postpone/get-by-party-case-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/party-case-postpone/update
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCasePostponeController.update
     */
    update$POST$onboarding_partycasepostpone_update(updatePartyCasePostponeDto: UpdatePartyCasePostponeDto, options?: O): RestResponse<WebResponseObject<PartyCasePostponeDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/party-case-postpone/update`, data: updatePartyCasePostponeDto, options: options });
    }

    /**
     * HTTP POST /onboarding/party-case-screening-list/add-party-case-to-screening-list
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCaseScreeningListController.addPartyCaseToScreeningList
     */
    addPartyCaseToScreeningList(addPartyCaseToScreeningListDto: AddPartyCaseToScreeningListDto, options?: O): RestResponse<WebResponseEntity<PartyCaseScreeningListDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/party-case-screening-list/add-party-case-to-screening-list`, data: addPartyCaseToScreeningListDto, options: options });
    }

    /**
     * HTTP GET /onboarding/party-case-screening-list/find-party-case-screening-lists
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCaseScreeningListController.findPartyCaseScreeningListsByPartyCaseId
     */
    findPartyCaseScreeningListsByPartyCaseId(queryParams: { partyCaseId: number; }, options?: O): RestResponse<WebListResponseEntity<PartyCaseScreeningListDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/party-case-screening-list/find-party-case-screening-lists`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /onboarding/party-case-screening-list/screening-list-types
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCaseScreeningListController.getScreeningListTypes
     */
    getScreeningListTypes(options?: O): RestResponse<WebListResponseEntity<ScreeningListTypeDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/party-case-screening-list/screening-list-types`, options: options });
    }

    /**
     * HTTP POST /onboarding/party-case-screening-list/search-screening-lists
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCaseScreeningListController.searchScreeningLists
     */
    searchScreeningLists(searchScreeningListDto: SearchScreeningListDto, options?: O): RestResponse<WebListResponseEntity<ScreeningListDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/party-case-screening-list/search-screening-lists`, data: searchScreeningListDto, options: options });
    }

    /**
     * HTTP POST /onboarding/party-case-screening-list/set-active-party-case-screening-list
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCaseScreeningListController.setActivePartyCaseScreeningList
     */
    setActivePartyCaseScreeningList(setActivePartyCaseScreeningListDto: SetActivePartyCaseScreeningListDto, options?: O): RestResponse<WebResponseEntity<PartyCaseScreeningListDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/party-case-screening-list/set-active-party-case-screening-list`, data: setActivePartyCaseScreeningListDto, options: options });
    }

    /**
     * HTTP POST /onboarding/party-case/change-status
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCaseController.changeStatus
     */
    changeStatus$POST$onboarding_partycase_changestatus(request: ChangeStatusPartyCaseDto, options?: O): RestResponse<WebResponseEntity<PartyCaseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/party-case/change-status`, data: request, options: options });
    }

    /**
     * HTTP POST /onboarding/party-case/create
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCaseController.create
     */
    create$POST$onboarding_partycase_create(dto: CreatePartyCaseDto, options?: O): RestResponse<WebResponseEntity<PartyCaseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/party-case/create`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/party-case/delete
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCaseController.deleteById
     */
    deleteById$POST$onboarding_partycase_delete(request: DeleteRequest<number>, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/party-case/delete`, data: request, options: options });
    }

    /**
     * HTTP POST /onboarding/party-case/get-all
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCaseController.findAll
     */
    findAll$POST$onboarding_partycase_getall(request: SearchRequest, options?: O): RestResponse<WebPageResponseEntity<PartyCaseTreeDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/party-case/get-all`, data: request, options: options });
    }

    /**
     * HTTP GET /onboarding/party-case/get-by-id
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCaseController.findById
     */
    findById$GET$onboarding_partycase_getbyid(queryParams: { id: number; }, options?: O): RestResponse<WebResponseEntity<PartyCaseTreeDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/party-case/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /onboarding/party-case/get-party-case-by-service-code-and-user
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCaseController.getPartyCaseByServiceCodeForApplicationAndUser
     */
    getPartyCaseByServiceCodeForApplicationAndUser(queryParams: { serviceCode: string; }, options?: O): RestResponse<WebResponseEntity<PartyCaseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/party-case/get-party-case-by-service-code-and-user`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /onboarding/party-case/get-party-case-verification-by-entry-id
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCaseController.getPartyCaseVerificationByEntryId
     */
    getPartyCaseVerificationByEntryId(queryParams: { entryId: string; }, options?: O): RestResponse<Mono<WebResponseEntity<PartyCaseVerificationDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/party-case/get-party-case-verification-by-entry-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /onboarding/party-case/get-party-case-verification-for-user
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCaseController.getPartyCaseVerificationForUser
     */
    getPartyCaseVerificationForUser(queryParams: { serviceCode: string; }, options?: O): RestResponse<Mono<WebResponseEntity<PartyCaseVerificationDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/party-case/get-party-case-verification-for-user`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /onboarding/party-case/group/list
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCaseController.getPartyCaseGroupsByPartyId
     */
    getPartyCaseGroupsByPartyId(queryParams: { partyId: string; }, options?: O): RestResponse<WebListResponseEntity<PartyCaseGroupDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/party-case/group/list`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/party-case/list
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCaseController.getPartyCasesByPartyId
     */
    getPartyCasesByPartyId(request: SearchRequest, queryParams: { partyId: string; }, options?: O): RestResponse<WebPageResponseEntity<PartyCaseTreeDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/party-case/list`, queryParams: queryParams, data: request, options: options });
    }

    /**
     * HTTP GET /onboarding/party-case/prepare-for-expiry-notify
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCaseController.preparePartyCaseForExpiryNotify
     */
    preparePartyCaseForExpiryNotify(queryParams: { id: number; }, options?: O): RestResponse<WebResponseEntity<PartyCaseTreeDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/party-case/prepare-for-expiry-notify`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /onboarding/party-case/prepare-for-set-expired
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCaseController.preparePartyCaseForSetExpired
     */
    preparePartyCaseForSetExpired(queryParams: { id: number; }, options?: O): RestResponse<WebResponseEntity<PartyCaseTreeDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/party-case/prepare-for-set-expired`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/party-case/update
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCaseController.update
     */
    update$POST$onboarding_partycase_update(dto: UpdatePartyCaseDto, options?: O): RestResponse<WebResponseEntity<PartyCaseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/party-case/update`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/party-case/verification
     * Java method: com.europoint.onboarding.webapi.controllers.PartyCaseController.setVerification
     */
    setVerification(dto: SetPartyCaseVerificationDto, options?: O): RestResponse<WebResponseEntity<PartyCaseTreeDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/party-case/verification`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/party-type/create
     * Java method: com.europoint.onboarding.webapi.controllers.PartyTypeController.create
     */
    create$POST$onboarding_partytype_create(dto: CreatePartyTypeDto, options?: O): RestResponse<WebResponseEntity<PartyTypeDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/party-type/create`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/party-type/delete
     * Java method: com.europoint.onboarding.webapi.controllers.PartyTypeController.deleteById
     */
    deleteById$POST$onboarding_partytype_delete(request: DeleteRequest<number>, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/party-type/delete`, data: request, options: options });
    }

    /**
     * HTTP GET /onboarding/party-type/get-all
     * Java method: com.europoint.onboarding.webapi.controllers.PartyTypeController.findAll
     */
    findAll$GET$onboarding_partytype_getall(options?: O): RestResponse<WebListResponseEntity<PartyTypeDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/party-type/get-all`, options: options });
    }

    /**
     * HTTP GET /onboarding/party-type/get-by-application
     * Java method: com.europoint.onboarding.webapi.controllers.PartyTypeController.findByApplicationId
     */
    findByApplicationId(options?: O): RestResponse<WebListResponseEntity<PartyTypeDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/party-type/get-by-application`, options: options });
    }

    /**
     * HTTP GET /onboarding/party-type/get-by-id
     * Java method: com.europoint.onboarding.webapi.controllers.PartyTypeController.findById
     */
    findById$GET$onboarding_partytype_getbyid(queryParams: { id: number; }, options?: O): RestResponse<WebResponseEntity<PartyTypeDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/party-type/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/party-type/update
     * Java method: com.europoint.onboarding.webapi.controllers.PartyTypeController.update
     */
    update$POST$onboarding_partytype_update(dto: UpdatePartyTypeDto, options?: O): RestResponse<WebResponseEntity<PartyTypeDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/party-type/update`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/party/agent/find-for-agent
     * Java method: com.europoint.onboarding.webapi.controllers.AgentPartyController.findForAgent
     */
    findForAgent(dto: SearchAgentPartyDto, options?: O): RestResponse<WebListResponseEntity<AgentPartyDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/party/agent/find-for-agent`, data: dto, options: options });
    }

    /**
     * HTTP GET /onboarding/party/agent/get-by-id
     * Java method: com.europoint.onboarding.webapi.controllers.AgentPartyController.getById
     */
    getById(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<AgentPartyDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/party/agent/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/party/create
     * Java method: com.europoint.onboarding.webapi.controllers.PartyController.create
     */
    create$POST$onboarding_party_create(dto: CreatePartyDto, options?: O): RestResponse<WebResponseEntity<PartyDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/party/create`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/party/delete
     * Java method: com.europoint.onboarding.webapi.controllers.PartyController.deleteById
     */
    deleteById$POST$onboarding_party_delete(request: DeleteRequest<string>, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/party/delete`, data: request, options: options });
    }

    /**
     * HTTP POST /onboarding/party/get-all
     * Java method: com.europoint.onboarding.webapi.controllers.PartyController.findAll
     */
    findAll$POST$onboarding_party_getall(request: SearchRequest, options?: O): RestResponse<WebPageResponseEntity<PartyDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/party/get-all`, data: request, options: options });
    }

    /**
     * HTTP GET /onboarding/party/get-by-id
     * Java method: com.europoint.onboarding.webapi.controllers.PartyController.findById
     */
    findById$GET$onboarding_party_getbyid(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<PartyDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/party/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /onboarding/party/get-by-self-user
     * Java method: com.europoint.onboarding.webapi.controllers.PartyController.findPartyBySelfUser
     */
    findPartyBySelfUser(options?: O): RestResponse<WebResponseEntity<PartyDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/party/get-by-self-user`, options: options });
    }

    /**
     * HTTP GET /onboarding/party/get-sub-services-by-party-id
     * Java method: com.europoint.onboarding.webapi.controllers.PartyController.getPartyServices
     */
    getPartyServices(queryParams: { partyTypeId: number; }, options?: O): RestResponse<WebListResponseEntity<string>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/party/get-sub-services-by-party-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/pqfilled/delete
     * Java method: com.europoint.onboarding.webapi.controllers.PartyQuestionnaireFilledController.deleteById
     */
    deleteById$POST$onboarding_pqfilled_delete(request: DeleteRequest<number>, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/pqfilled/delete`, data: request, options: options });
    }

    /**
     * HTTP POST /onboarding/pqfilled/end-filling
     * Java method: com.europoint.onboarding.webapi.controllers.PartyQuestionnaireFilledController.endFilling
     */
    endFilling(dto: FillingPartyQuestionnaireDto, options?: O): RestResponse<WebResponseEntity<PartyQuestionnaireFilledDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/pqfilled/end-filling`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/pqfilled/get-all
     * Java method: com.europoint.onboarding.webapi.controllers.PartyQuestionnaireFilledController.findAll
     */
    findAll$POST$onboarding_pqfilled_getall(request: SearchRequest, options?: O): RestResponse<WebPageResponseEntity<PartyQuestionnaireFilledDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/pqfilled/get-all`, data: request, options: options });
    }

    /**
     * HTTP GET /onboarding/pqfilled/get-by-id
     * Java method: com.europoint.onboarding.webapi.controllers.PartyQuestionnaireFilledController.findById
     */
    findById$GET$onboarding_pqfilled_getbyid(queryParams: { id: number; }, options?: O): RestResponse<WebResponseEntity<PartyQuestionnaireFilledDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/pqfilled/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /onboarding/pqfilled/get-by-party-case-and-questionnaire-id
     * Java method: com.europoint.onboarding.webapi.controllers.PartyQuestionnaireFilledController.findByPartyCaseAndQuestionnaireId
     */
    findByPartyCaseAndQuestionnaireId(queryParams: { partyCaseId: number; questionnaireId: number; }, options?: O): RestResponse<WebResponseEntity<PartyQuestionnaireFilledDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/pqfilled/get-by-party-case-and-questionnaire-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/pqfilled/start-filling
     * Java method: com.europoint.onboarding.webapi.controllers.PartyQuestionnaireFilledController.startFilling
     */
    startFilling(dto: FillingPartyQuestionnaireDto, options?: O): RestResponse<WebResponseEntity<PartyQuestionnaireFilledDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/pqfilled/start-filling`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/process/create
     * Java method: com.europoint.onboarding.webapi.controllers.ProcessController.create
     */
    create$POST$onboarding_process_create(createProcessDto: CreateProcessDto, options?: O): RestResponse<WebResponseEntity<ProcessDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/process/create`, data: createProcessDto, options: options });
    }

    /**
     * HTTP POST /onboarding/process/delete
     * Java method: com.europoint.onboarding.webapi.controllers.ProcessController.delete
     */
    delete$POST$onboarding_process_delete(request: DeleteRequest<number>, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/process/delete`, data: request, options: options });
    }

    /**
     * HTTP GET /onboarding/process/find-all
     * Java method: com.europoint.onboarding.webapi.controllers.ProcessController.findAll
     */
    findAll$GET$onboarding_process_findall(options?: O): RestResponse<WebListResponseEntity<ProcessDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/process/find-all`, options: options });
    }

    /**
     * HTTP GET /onboarding/process/get-by-id
     * Java method: com.europoint.onboarding.webapi.controllers.ProcessController.findById
     */
    findById$GET$onboarding_process_getbyid(queryParams: { id: number; }, options?: O): RestResponse<WebResponseObject<ProcessDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/process/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/process/update
     * Java method: com.europoint.onboarding.webapi.controllers.ProcessController.update
     */
    update$POST$onboarding_process_update(updateProcessDto: UpdateProcessDto, options?: O): RestResponse<WebResponseEntity<ProcessDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/process/update`, data: updateProcessDto, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/change-status
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireController.changeStatus
     */
    changeStatus$POST$onboarding_questionnaire_changestatus(request: ChangeStatusQuestionnaireRequest, options?: O): RestResponse<WebResponseEntity<QuestionnaireDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/change-status`, data: request, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/create
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireController.create
     */
    create$POST$onboarding_questionnaire_create(dto: CreateQuestionnaireDto, options?: O): RestResponse<WebResponseEntity<QuestionnaireDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/create`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/delete
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireController.deleteById
     */
    deleteById$POST$onboarding_questionnaire_delete(request: DeleteRequest<number>, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/delete`, data: request, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/field/create
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireFieldController.create
     */
    create$POST$onboarding_questionnaire_field_create(dto: CreateQuestionnaireFieldDto, options?: O): RestResponse<WebResponseEntity<QuestionnaireFieldDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/field/create`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/field/create-from-list
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireFieldController.createFromList
     */
    createFromList(dto: QuestionnaireFieldRequestDto, options?: O): RestResponse<WebResponseEntity<QuestionnaireFieldDto[]>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/field/create-from-list`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/field/create-from-template
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireFieldController.createFromTemplate
     */
    createFromTemplate(dto: QuestionnaireFieldFromTemplateDto, options?: O): RestResponse<WebResponseEntity<QuestionnaireFieldDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/field/create-from-template`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/field/delete
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireFieldController.deleteById
     */
    deleteById$POST$onboarding_questionnaire_field_delete(request: DeleteRequest<number>, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/field/delete`, data: request, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/field/get-all-by-questionnaire-id
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireFieldController.findAll
     */
    findAll$POST$onboarding_questionnaire_field_getallbyquestionnaireid(queryParams: { questionnaireId: number; }, options?: O): RestResponse<WebListResponseEntity<QuestionnaireFieldDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/field/get-all-by-questionnaire-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /onboarding/questionnaire/field/get-by-id
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireFieldController.findById
     */
    findById$GET$onboarding_questionnaire_field_getbyid(queryParams: { id: number; }, options?: O): RestResponse<WebResponseEntity<QuestionnaireFieldDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/questionnaire/field/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/field/order-move
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireFieldController.orderMove
     */
    orderMove(request: QuestionnaireFieldOrderRequest, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/field/order-move`, data: request, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/field/order-swap
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireFieldController.orderSwap
     */
    orderSwap(request: QuestionnaireFieldOrderRequest, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/field/order-swap`, data: request, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/field/update
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireFieldController.update
     */
    update$POST$onboarding_questionnaire_field_update(dto: UpdateQuestionnaireFieldDto, options?: O): RestResponse<WebResponseEntity<QuestionnaireFieldDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/field/update`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/get-all
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireController.findAll
     */
    findAll$POST$onboarding_questionnaire_getall(request: SearchRequest, options?: O): RestResponse<WebPageResponseEntity<QuestionnaireDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/get-all`, data: request, options: options });
    }

    /**
     * HTTP GET /onboarding/questionnaire/get-by-id
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireController.findById
     */
    findById$GET$onboarding_questionnaire_getbyid(queryParams: { id: number; }, options?: O): RestResponse<WebResponseEntity<QuestionnaireDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/questionnaire/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /onboarding/questionnaire/get-full-questionnaire-by-id
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireController.findFullById
     */
    findFullById(queryParams: { id: number; }, options?: O): RestResponse<WebResponseEntity<QuestionnaireDtoFull>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/questionnaire/get-full-questionnaire-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /onboarding/questionnaire/get-questionnaires-by-ids
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireController.findByIds
     */
    findByIds(queryParams: { ids: number[]; }, options?: O): RestResponse<WebListResponseEntity<QuestionnaireDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/questionnaire/get-questionnaires-by-ids`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/risk-score/create
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireRiskScoreController.create
     */
    create$POST$onboarding_questionnaire_riskscore_create(dto: CreateQuestionnaireRiskDto, options?: O): RestResponse<WebResponseEntity<QuestionnaireRiskDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/risk-score/create`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/risk-score/delete
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireRiskScoreController.deleteById
     */
    deleteById$POST$onboarding_questionnaire_riskscore_delete(request: DeleteRequest<number>, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/risk-score/delete`, data: request, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/risk-score/get-all
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireRiskScoreController.findAll
     */
    findAll$POST$onboarding_questionnaire_riskscore_getall(request: SearchRequest, options?: O): RestResponse<WebPageResponseEntity<QuestionnaireRiskDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/risk-score/get-all`, data: request, options: options });
    }

    /**
     * HTTP GET /onboarding/questionnaire/risk-score/get-by-id
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireRiskScoreController.findById
     */
    findById$GET$onboarding_questionnaire_riskscore_getbyid(queryParams: { id: number; }, options?: O): RestResponse<WebResponseEntity<QuestionnaireRiskDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/questionnaire/risk-score/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /onboarding/questionnaire/risk-score/q
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireRiskScoreController.findByQuestionnaireId
     */
    findByQuestionnaireId(request: SearchRequest, queryParams: { questionnaireId: number; }, options?: O): RestResponse<WebPageResponseEntity<RiskScoreDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/questionnaire/risk-score/q`, queryParams: queryParams, data: request, options: options });
    }

    /**
     * HTTP GET /onboarding/questionnaire/risk-score/r
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireRiskScoreController.findByRiskScoreId
     */
    findByRiskScoreId(request: SearchRequest, queryParams: { riskScoreId: number; }, options?: O): RestResponse<WebPageResponseEntity<QuestionnaireDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/questionnaire/risk-score/r`, queryParams: queryParams, data: request, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/risk-score/update
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireRiskScoreController.update
     */
    update$POST$onboarding_questionnaire_riskscore_update(dto: UpdateQuestionnaireRiskDto, options?: O): RestResponse<WebResponseEntity<QuestionnaireRiskDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/risk-score/update`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/set/create
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireSetController.create
     */
    create$POST$onboarding_questionnaire_set_create(dto: CreateQuestionnaireSetDto, options?: O): RestResponse<WebResponseEntity<QuestionnaireSetDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/set/create`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/set/delete
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireSetController.deleteById
     */
    deleteById$POST$onboarding_questionnaire_set_delete(request: DeleteRequest<number>, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/set/delete`, data: request, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/set/get-all
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireSetController.findAll
     */
    findAll$POST$onboarding_questionnaire_set_getall(options?: O): RestResponse<WebListResponseEntity<QuestionnaireSetDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/set/get-all`, options: options });
    }

    /**
     * HTTP GET /onboarding/questionnaire/set/get-all-by-party-type
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireSetController.findByPartyType
     */
    findByPartyType(queryParams: { partyTypeId: number; }, options?: O): RestResponse<WebListResponseEntity<QuestionnaireSetDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/questionnaire/set/get-all-by-party-type`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /onboarding/questionnaire/set/get-all-sub-service-codes
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireSetController.getAllSubServiceCodes
     */
    getAllSubServiceCodes(options?: O): RestResponse<WebListResponseEntity<string>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/questionnaire/set/get-all-sub-service-codes`, options: options });
    }

    /**
     * HTTP GET /onboarding/questionnaire/set/get-by-application-and-service-code
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireSetController.findFullQuestionnaireSetsByApplicationAndServiceCode
     */
    findFullQuestionnaireSetsByApplicationAndServiceCode(queryParams: { serviceCode: string; }, options?: O): RestResponse<WebListResponseEntity<QuestionnaireSetDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/questionnaire/set/get-by-application-and-service-code`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /onboarding/questionnaire/set/get-by-id
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireSetController.findById
     */
    findById$GET$onboarding_questionnaire_set_getbyid(queryParams: { id: number; }, options?: O): RestResponse<WebResponseEntity<QuestionnaireSetDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/questionnaire/set/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /onboarding/questionnaire/set/get-for-party-case
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireSetController.getQuestionnaireByPartyCase
     */
    getQuestionnaireByPartyCase(queryParams: { partyCaseId: number; }, options?: O): RestResponse<WebListResponseEntity<QuestionnaireSetDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/questionnaire/set/get-for-party-case`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /onboarding/questionnaire/set/p
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireSetController.findQuestionnaireListByPartyTypeAndServiceType
     */
    findQuestionnaireListByPartyTypeAndServiceType(queryParams: { partyTypeId: number; serviceCode: string; }, options?: O): RestResponse<WebListResponseEntity<QuestionnaireSetDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/questionnaire/set/p`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/set/update
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireSetController.update
     */
    update$POST$onboarding_questionnaire_set_update(dto: UpdateQuestionnaireSetDto, options?: O): RestResponse<WebResponseEntity<QuestionnaireSetDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/set/update`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/questionnaire/update
     * Java method: com.europoint.onboarding.webapi.controllers.QuestionnaireController.update
     */
    update$POST$onboarding_questionnaire_update(dto: UpdateQuestionnaireDto, options?: O): RestResponse<WebResponseEntity<QuestionnaireDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/questionnaire/update`, data: dto, options: options });
    }

    /**
     * HTTP GET /onboarding/report/count-party-cases-by-status
     * Java method: com.europoint.onboarding.webapi.controllers.ReportController.countPartyCasesByStatus
     */
    countPartyCasesByStatus(options?: O): RestResponse<WebListResponseEntity<ReportDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/report/count-party-cases-by-status`, options: options });
    }

    /**
     * HTTP POST /onboarding/risk-score/create
     * Java method: com.europoint.onboarding.webapi.controllers.RiskScoreController.create
     */
    create$POST$onboarding_riskscore_create(dto: CreateRiskScoreDto, options?: O): RestResponse<WebResponseEntity<RiskScoreDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/risk-score/create`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/risk-score/delete
     * Java method: com.europoint.onboarding.webapi.controllers.RiskScoreController.deleteById
     */
    deleteById$POST$onboarding_riskscore_delete(request: DeleteRequest<number>, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/risk-score/delete`, data: request, options: options });
    }

    /**
     * HTTP GET /onboarding/risk-score/get-all
     * Java method: com.europoint.onboarding.webapi.controllers.RiskScoreController.findAll
     */
    findAll$GET$onboarding_riskscore_getall(options?: O): RestResponse<WebListResponseEntity<RiskScoreDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/risk-score/get-all`, options: options });
    }

    /**
     * HTTP GET /onboarding/risk-score/get-by-id
     * Java method: com.europoint.onboarding.webapi.controllers.RiskScoreController.findById
     */
    findById$GET$onboarding_riskscore_getbyid(queryParams: { id: number; }, options?: O): RestResponse<WebResponseEntity<RiskScoreDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/risk-score/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/risk-score/update
     * Java method: com.europoint.onboarding.webapi.controllers.RiskScoreController.update
     */
    update$POST$onboarding_riskscore_update(dto: UpdateRiskScoreDto, options?: O): RestResponse<WebResponseEntity<RiskScoreDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/risk-score/update`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/template-field/create
     * Java method: com.europoint.onboarding.webapi.controllers.TemplateFieldController.create
     */
    create$POST$onboarding_templatefield_create(dto: CreateTemplateFieldDto, options?: O): RestResponse<WebResponseEntity<TemplateFieldDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/template-field/create`, data: dto, options: options });
    }

    /**
     * HTTP POST /onboarding/template-field/delete
     * Java method: com.europoint.onboarding.webapi.controllers.TemplateFieldController.deleteById
     */
    deleteById$POST$onboarding_templatefield_delete(request: DeleteRequest<number>, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/template-field/delete`, data: request, options: options });
    }

    /**
     * HTTP GET /onboarding/template-field/get-all
     * Java method: com.europoint.onboarding.webapi.controllers.TemplateFieldController.findAll
     */
    findAll$GET$onboarding_templatefield_getall(options?: O): RestResponse<WebListResponseEntity<TemplateFieldDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/template-field/get-all`, options: options });
    }

    /**
     * HTTP GET /onboarding/template-field/get-by-id
     * Java method: com.europoint.onboarding.webapi.controllers.TemplateFieldController.findById
     */
    findById$GET$onboarding_templatefield_getbyid(queryParams: { id: number; }, options?: O): RestResponse<WebResponseEntity<TemplateFieldDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`onboarding/template-field/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /onboarding/template-field/update
     * Java method: com.europoint.onboarding.webapi.controllers.TemplateFieldController.update
     */
    update$POST$onboarding_templatefield_update(dto: UpdateTemplateFieldDto, options?: O): RestResponse<WebResponseEntity<TemplateFieldDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`onboarding/template-field/update`, data: dto, options: options });
    }
}

export type RestResponse<R> = Promise<Axios.GenericAxiosResponse<R>>;

export type DateAsString = string;

export type FieldInfoUnion = StringField | IntegerField | DateField | DateTimeField | ListDynamicField | ListStaticField | ListQuestionField | OwnershipField | BooleanField | LabelField;

export const enum CodeProvider {
    UNDEFINED = "UNDEFINED",
    SMS = "SMS",
    EMAIL = "EMAIL",
}

export const enum QuestionnaireStatus {
    CREATED = "CREATED",
    FORMING = "FORMING",
    PREPARED = "PREPARED",
    VERIFIED = "VERIFIED",
    ACTIVATED = "ACTIVATED",
    REJECTED = "REJECTED",
    DEACTIVATED = "DEACTIVATED",
    DELETED = "DELETED",
    CLOSED = "CLOSED",
}

/**
 * Values:
 * - `CONTINUE`
 * - `SWITCHING_PROTOCOLS`
 * - `PROCESSING`
 * - `CHECKPOINT`
 * - `OK`
 * - `CREATED`
 * - `ACCEPTED`
 * - `NON_AUTHORITATIVE_INFORMATION`
 * - `NO_CONTENT`
 * - `RESET_CONTENT`
 * - `PARTIAL_CONTENT`
 * - `MULTI_STATUS`
 * - `ALREADY_REPORTED`
 * - `IM_USED`
 * - `MULTIPLE_CHOICES`
 * - `MOVED_PERMANENTLY`
 * - `FOUND`
 * - `MOVED_TEMPORARILY` - @deprecated
 * - `SEE_OTHER`
 * - `NOT_MODIFIED`
 * - `USE_PROXY` - @deprecated
 * - `TEMPORARY_REDIRECT`
 * - `PERMANENT_REDIRECT`
 * - `BAD_REQUEST`
 * - `UNAUTHORIZED`
 * - `PAYMENT_REQUIRED`
 * - `FORBIDDEN`
 * - `NOT_FOUND`
 * - `METHOD_NOT_ALLOWED`
 * - `NOT_ACCEPTABLE`
 * - `PROXY_AUTHENTICATION_REQUIRED`
 * - `REQUEST_TIMEOUT`
 * - `CONFLICT`
 * - `GONE`
 * - `LENGTH_REQUIRED`
 * - `PRECONDITION_FAILED`
 * - `PAYLOAD_TOO_LARGE`
 * - `REQUEST_ENTITY_TOO_LARGE` - @deprecated
 * - `URI_TOO_LONG`
 * - `REQUEST_URI_TOO_LONG` - @deprecated
 * - `UNSUPPORTED_MEDIA_TYPE`
 * - `REQUESTED_RANGE_NOT_SATISFIABLE`
 * - `EXPECTATION_FAILED`
 * - `I_AM_A_TEAPOT`
 * - `INSUFFICIENT_SPACE_ON_RESOURCE` - @deprecated
 * - `METHOD_FAILURE` - @deprecated
 * - `DESTINATION_LOCKED` - @deprecated
 * - `UNPROCESSABLE_ENTITY`
 * - `LOCKED`
 * - `FAILED_DEPENDENCY`
 * - `TOO_EARLY`
 * - `UPGRADE_REQUIRED`
 * - `PRECONDITION_REQUIRED`
 * - `TOO_MANY_REQUESTS`
 * - `REQUEST_HEADER_FIELDS_TOO_LARGE`
 * - `UNAVAILABLE_FOR_LEGAL_REASONS`
 * - `INTERNAL_SERVER_ERROR`
 * - `NOT_IMPLEMENTED`
 * - `BAD_GATEWAY`
 * - `SERVICE_UNAVAILABLE`
 * - `GATEWAY_TIMEOUT`
 * - `HTTP_VERSION_NOT_SUPPORTED`
 * - `VARIANT_ALSO_NEGOTIATES`
 * - `INSUFFICIENT_STORAGE`
 * - `LOOP_DETECTED`
 * - `BANDWIDTH_LIMIT_EXCEEDED`
 * - `NOT_EXTENDED`
 * - `NETWORK_AUTHENTICATION_REQUIRED`
 */
export const enum HttpStatus {
    CONTINUE = "CONTINUE",
    SWITCHING_PROTOCOLS = "SWITCHING_PROTOCOLS",
    PROCESSING = "PROCESSING",
    CHECKPOINT = "CHECKPOINT",
    OK = "OK",
    CREATED = "CREATED",
    ACCEPTED = "ACCEPTED",
    NON_AUTHORITATIVE_INFORMATION = "NON_AUTHORITATIVE_INFORMATION",
    NO_CONTENT = "NO_CONTENT",
    RESET_CONTENT = "RESET_CONTENT",
    PARTIAL_CONTENT = "PARTIAL_CONTENT",
    MULTI_STATUS = "MULTI_STATUS",
    ALREADY_REPORTED = "ALREADY_REPORTED",
    IM_USED = "IM_USED",
    MULTIPLE_CHOICES = "MULTIPLE_CHOICES",
    MOVED_PERMANENTLY = "MOVED_PERMANENTLY",
    FOUND = "FOUND",
    /**
     * @deprecated
     */
    MOVED_TEMPORARILY = "MOVED_TEMPORARILY",
    SEE_OTHER = "SEE_OTHER",
    NOT_MODIFIED = "NOT_MODIFIED",
    /**
     * @deprecated
     */
    USE_PROXY = "USE_PROXY",
    TEMPORARY_REDIRECT = "TEMPORARY_REDIRECT",
    PERMANENT_REDIRECT = "PERMANENT_REDIRECT",
    BAD_REQUEST = "BAD_REQUEST",
    UNAUTHORIZED = "UNAUTHORIZED",
    PAYMENT_REQUIRED = "PAYMENT_REQUIRED",
    FORBIDDEN = "FORBIDDEN",
    NOT_FOUND = "NOT_FOUND",
    METHOD_NOT_ALLOWED = "METHOD_NOT_ALLOWED",
    NOT_ACCEPTABLE = "NOT_ACCEPTABLE",
    PROXY_AUTHENTICATION_REQUIRED = "PROXY_AUTHENTICATION_REQUIRED",
    REQUEST_TIMEOUT = "REQUEST_TIMEOUT",
    CONFLICT = "CONFLICT",
    GONE = "GONE",
    LENGTH_REQUIRED = "LENGTH_REQUIRED",
    PRECONDITION_FAILED = "PRECONDITION_FAILED",
    PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE",
    /**
     * @deprecated
     */
    REQUEST_ENTITY_TOO_LARGE = "REQUEST_ENTITY_TOO_LARGE",
    URI_TOO_LONG = "URI_TOO_LONG",
    /**
     * @deprecated
     */
    REQUEST_URI_TOO_LONG = "REQUEST_URI_TOO_LONG",
    UNSUPPORTED_MEDIA_TYPE = "UNSUPPORTED_MEDIA_TYPE",
    REQUESTED_RANGE_NOT_SATISFIABLE = "REQUESTED_RANGE_NOT_SATISFIABLE",
    EXPECTATION_FAILED = "EXPECTATION_FAILED",
    I_AM_A_TEAPOT = "I_AM_A_TEAPOT",
    /**
     * @deprecated
     */
    INSUFFICIENT_SPACE_ON_RESOURCE = "INSUFFICIENT_SPACE_ON_RESOURCE",
    /**
     * @deprecated
     */
    METHOD_FAILURE = "METHOD_FAILURE",
    /**
     * @deprecated
     */
    DESTINATION_LOCKED = "DESTINATION_LOCKED",
    UNPROCESSABLE_ENTITY = "UNPROCESSABLE_ENTITY",
    LOCKED = "LOCKED",
    FAILED_DEPENDENCY = "FAILED_DEPENDENCY",
    TOO_EARLY = "TOO_EARLY",
    UPGRADE_REQUIRED = "UPGRADE_REQUIRED",
    PRECONDITION_REQUIRED = "PRECONDITION_REQUIRED",
    TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS",
    REQUEST_HEADER_FIELDS_TOO_LARGE = "REQUEST_HEADER_FIELDS_TOO_LARGE",
    UNAVAILABLE_FOR_LEGAL_REASONS = "UNAVAILABLE_FOR_LEGAL_REASONS",
    INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
    NOT_IMPLEMENTED = "NOT_IMPLEMENTED",
    BAD_GATEWAY = "BAD_GATEWAY",
    SERVICE_UNAVAILABLE = "SERVICE_UNAVAILABLE",
    GATEWAY_TIMEOUT = "GATEWAY_TIMEOUT",
    HTTP_VERSION_NOT_SUPPORTED = "HTTP_VERSION_NOT_SUPPORTED",
    VARIANT_ALSO_NEGOTIATES = "VARIANT_ALSO_NEGOTIATES",
    INSUFFICIENT_STORAGE = "INSUFFICIENT_STORAGE",
    LOOP_DETECTED = "LOOP_DETECTED",
    BANDWIDTH_LIMIT_EXCEEDED = "BANDWIDTH_LIMIT_EXCEEDED",
    NOT_EXTENDED = "NOT_EXTENDED",
    NETWORK_AUTHENTICATION_REQUIRED = "NETWORK_AUTHENTICATION_REQUIRED",
}

export const enum PartyCaseStatus {
    PENDING = "PENDING",
    DRAFT = "DRAFT",
    SUBMITTED = "SUBMITTED",
    INITIATED_VIDEO_IDENTIFICATION = "INITIATED_VIDEO_IDENTIFICATION",
    APPROVED_VIDEO_IDENTIFICATION = "APPROVED_VIDEO_IDENTIFICATION",
    REJECTED_VIDEO_IDENTIFICATION = "REJECTED_VIDEO_IDENTIFICATION",
    RECEIVED = "RECEIVED",
    PROCESSING_AML = "PROCESSING_AML",
    COMPLETED_AML = "COMPLETED_AML",
    PROCESSING_RISK = "PROCESSING_RISK",
    REJECTED_PROCESSING = "REJECTED_PROCESSING",
    REJECTED_AML = "REJECTED_AML",
    REJECTED_RISK = "REJECTED_RISK",
    RE_SUBMITTED = "RE_SUBMITTED",
    COMPLETED = "COMPLETED",
    EXPIRED = "EXPIRED",
    DELETE_REQUESTED = "DELETE_REQUESTED",
    DELETED = "DELETED",
}

export const enum VerificationType {
    UNDEFINED = "UNDEFINED",
    NOT_NEEDED = "NOT_NEEDED",
    IN_PERSON = "IN_PERSON",
    ONLINE = "ONLINE",
}

export const enum CompletedStatusExpirationNotifyInterval {
    WEEKLY = "WEEKLY",
    DAILY = "DAILY",
    HOURLY = "HOURLY",
}

export const enum PartyTypeEntityType {
    LEGAL_ENTITY_USER = "LEGAL_ENTITY_USER",
    LEGAL_ENTITY_CONSUMER = "LEGAL_ENTITY_CONSUMER",
    LEGAL_ENTITY_CONTACT = "LEGAL_ENTITY_CONTACT",
    PERSON_USER = "PERSON_USER",
    PERSON_CONSUMER = "PERSON_CONSUMER",
    PERSON_CONTACT = "PERSON_CONTACT",
}

export const enum QuestionnaireFieldIdentity {
    none = "none",
    firstName = "firstName",
    middleName = "middleName",
    parentName = "parentName",
    lastName = "lastName",
    personalId = "personalId",
    dateOfBirth = "dateOfBirth",
    placeOfBirth = "placeOfBirth",
    stateOfBirth = "stateOfBirth",
    countryOfBirth = "countryOfBirth",
    countryOfIdIssue = "countryOfIdIssue",
    idNumber = "idNumber",
    idType = "idType",
    idIssuer = "idIssuer",
    idDateOfIssue = "idDateOfIssue",
    idExpiryDate = "idExpiryDate",
    idPermanent = "idPermanent",
    cityOfResidence = "cityOfResidence",
    zip = "zip",
    countryOfResidence = "countryOfResidence",
    email = "email",
    resident = "resident",
    citizenship = "citizenship",
    streetName = "streetName",
    place = "place",
    addressType = "addressType",
    residenceNumber = "residenceNumber",
    stateOfResidence = "stateOfResidence",
    phoneNumber = "phoneNumber",
    mobileNumber = "mobileNumber",
    additionalNote = "additionalNote",
    maternalName = "maternalName",
    occupation = "occupation",
    mailingAddress = "mailingAddress",
    companyName = "companyName",
    tradeName = "tradeName",
    typeOfLegalEntity = "typeOfLegalEntity",
    companyRegistrationNumber = "companyRegistrationNumber",
    taxNumber = "taxNumber",
    registeredActivity = "registeredActivity",
    registrationDate = "registrationDate",
    stateOfRegistration = "stateOfRegistration",
    countryOfRegistration = "countryOfRegistration",
    numberOfYearsInBusiness = "numberOfYearsInBusiness",
    industry = "industry",
    registrationAddress = "registrationAddress",
    city = "city",
    postalCode = "postalCode",
    primaryPhoneNumber = "primaryPhoneNumber",
    webSite = "webSite",
    businessType = "businessType",
    category = "category",
    statisticalGroup = "statisticalGroup",
    businessTypeOfClient = "businessTypeOfClient",
    businessInvolvedInFollowingIndustries = "businessInvolvedInFollowingIndustries",
    typeOfRelationship = "typeOfRelationship",
}

export const enum QuestionnaireType {
    INITIAL_ASSESSMENT = "INITIAL_ASSESSMENT",
    CONTROL_ASSESSMENT = "CONTROL_ASSESSMENT",
    OWNERSHIP_ASSESSMENT = "OWNERSHIP_ASSESSMENT",
    AUTO_PROCESS_ASSESSMENT = "AUTO_PROCESS_ASSESSMENT",
}

export const enum QuestionnaireSetType {
    INITIAL_ASSESSMENT = "INITIAL_ASSESSMENT",
    CONTROL_ASSESSMENT = "CONTROL_ASSESSMENT",
}

export const enum NotificationChannelType {
    DASHBOARD = "DASHBOARD",
    EMAIL_LIST = "EMAIL_LIST",
    BOTH = "BOTH",
}

export const enum Operator {
    EQUAL = "EQUAL",
    NOT_EQUAL = "NOT_EQUAL",
    LIKE = "LIKE",
    NOT_LIKE = "NOT_LIKE",
    STARTS_WITH = "STARTS_WITH",
    END_WITH = "END_WITH",
    IN = "IN",
    NOT_IN = "NOT_IN",
    GREATER_THAN = "GREATER_THAN",
    GREATER_OR_EQUAL_TO = "GREATER_OR_EQUAL_TO",
    LESS_THAN = "LESS_THAN",
    LESS_OR_EQUAL_TO = "LESS_OR_EQUAL_TO",
    BETWEEN = "BETWEEN",
}

export const enum FieldType {
    BOOLEAN = "BOOLEAN",
    CHAR = "CHAR",
    DATE = "DATE",
    INSTANT = "INSTANT",
    DOUBLE = "DOUBLE",
    INTEGER = "INTEGER",
    LONG = "LONG",
    STRING = "STRING",
    UUID = "UUID",
    ENUM_STRING = "ENUM_STRING",
}

export const enum SortDirection {
    ASC = "ASC",
    DESC = "DESC",
}

export const enum PartyCaseType {
    INITIAL_CASE = "INITIAL_CASE",
    CONTROL_CASE = "CONTROL_CASE",
}

export const enum QuestionnaireFieldType {
    STRING = "STRING",
    NUMBER = "NUMBER",
    DATE = "DATE",
    DATE_TIME = "DATE_TIME",
    STATIC_LIST = "STATIC_LIST",
    DYNAMIC_LIST = "DYNAMIC_LIST",
    QUESTION_LIST = "QUESTION_LIST",
    BOOLEAN = "BOOLEAN",
    LABEL = "LABEL",
    OWNERSHIP = "OWNERSHIP",
}

export const enum FillStatus {
    IN_PROGRESS = "IN_PROGRESS",
    FINISHED = "FINISHED",
    ERROR_NOT_ENOUGH_POINTS = "ERROR_NOT_ENOUGH_POINTS",
    ERROR_NOT_ON_TIME = "ERROR_NOT_ON_TIME",
}

export const enum QuestionnaireAction {
    MANAGE_FIELDS = "MANAGE_FIELDS",
    MOVE_TO_PREPARED = "MOVE_TO_PREPARED",
    MOVE_TO_VERIFIED = "MOVE_TO_VERIFIED",
    MOVE_TO_REJECTED = "MOVE_TO_REJECTED",
    MOVE_TO_DEACTIVATED = "MOVE_TO_DEACTIVATED",
    MOVE_TO_DELETED = "MOVE_TO_DELETED",
    MOVE_TO_CLOSED = "MOVE_TO_CLOSED",
    POPULATE = "POPULATE",
}

export const enum OwnerType {
    SOLE_PROPRIETORSHIP = "SOLE_PROPRIETORSHIP",
    PRIVATELY_HELD = "PRIVATELY_HELD",
    PUBLICLY_TRADED = "PUBLICLY_TRADED",
    GOVERNMENT_OWNED = "GOVERNMENT_OWNED",
    OTHER_HYBRID = "OTHER_HYBRID",
}

export const enum ValidationType {
    FIELD_IS_MANDATORY = "FIELD_IS_MANDATORY",
    LENGTH_IS_LONGER_THAN_ALLOWED = "LENGTH_IS_LONGER_THAN_ALLOWED",
    REGEX_DOES_NOT_MATCH = "REGEX_DOES_NOT_MATCH",
    LESS_THEN_MINIMUM = "LESS_THEN_MINIMUM",
    GRATER_THAN_MAXIMUM = "GRATER_THAN_MAXIMUM",
    AFTER_THAN_MAXIMUM_DATE = "AFTER_THAN_MAXIMUM_DATE",
    BEFORE_THAN_MINIMUM_DATE = "BEFORE_THAN_MINIMUM_DATE",
    MUST_BE_IN_THE_PAST = "MUST_BE_IN_THE_PAST",
    MUST_BE_IN_THE_FUTURE = "MUST_BE_IN_THE_FUTURE",
    RANGE_FIELDS_MISSING = "RANGE_FIELDS_MISSING",
    VALUE_NOT_OUTSIDE_RANGE = "VALUE_NOT_OUTSIDE_RANGE",
    INVALID_OWNERSHIP = "INVALID_OWNERSHIP",
    MISSING_SUB_QUESTIONNAIRE_DATA = "MISSING_SUB_QUESTIONNAIRE_DATA",
    VALUE_NOT_ALLOWED = "VALUE_NOT_ALLOWED",
    INVALID_CONTROL_NUMBER = "INVALID_CONTROL_NUMBER",
    EXTERNAL_VALIDATION = "EXTERNAL_VALIDATION",
}

export const enum PredefinedRegEx {
    EMAIL = "EMAIL",
    PHONE = "PHONE",
    JMBG = "JMBG",
    REGISTRATION_NUMBER = "REGISTRATION_NUMBER",
    VAT_NUMBER = "VAT_NUMBER",
    WEB_PAGE = "WEB_PAGE",
    CUSTOM = "CUSTOM",
}

export const enum ValidationMode {
    IN_THE_PAST = "IN_THE_PAST",
    IN_THE_FUTURE = "IN_THE_FUTURE",
    CUSTOM = "CUSTOM",
}

export const enum ListDynamicSource {
    SR_CITY_LIST = "SR_CITY_LIST",
    COUNTRY_LIST = "COUNTRY_LIST",
    NACE_CODE_LIST = "NACE_CODE_LIST",
    BUSINESS_TYPE = "BUSINESS_TYPE",
    BUSINESS_INDUSTRY = "BUSINESS_INDUSTRY",
    ID_TYPES = "ID_TYPES",
    ADDRESS_TYPES = "ADDRESS_TYPES",
}

export const enum LabelMode {
    DESCRIPTION = "DESCRIPTION",
    TITLE = "TITLE",
    SUBTITLE = "SUBTITLE",
    TITLE_SUBTITLE = "TITLE_SUBTITLE",
}

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}


// Added by 'AxiosClientExtension' extension

import axios from "axios";
import * as Axios from "axios";

declare module "axios" {
    export interface GenericAxiosResponse<R> extends Axios.AxiosResponse {
        data: R;
    }
}

class AxiosHttpClient implements HttpClient<Axios.AxiosRequestConfig> {

    constructor(private axios: Axios.AxiosInstance) {
    }

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: Axios.AxiosRequestConfig; }): RestResponse<R> {
        function assign(target: any, source?: any) {
            if (source != undefined) {
                for (const key in source) {
                    if (source.hasOwnProperty(key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        }

        const config: Axios.AxiosRequestConfig = {};
        config.method = requestConfig.method as typeof config.method;  // `string` in axios 0.16.0, `Method` in axios 0.19.0
        config.url = requestConfig.url;
        config.params = requestConfig.queryParams;
        config.data = requestConfig.data;
        assign(config, requestConfig.options);
        const copyFn = requestConfig.copyFn;

        const axiosResponse = this.axios.request(config);
        return axiosResponse.then(axiosResponse => {
            if (copyFn && axiosResponse.data) {
                (axiosResponse as any).originalData = axiosResponse.data;
                axiosResponse.data = copyFn(axiosResponse.data);
            }
            return axiosResponse;
        });
    }
}

export class AxiosRestApplicationClient extends RestApplicationClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}
